import { render, staticRenderFns } from "./PendingRequests.vue?vue&type=template&id=684832d0&"
import script from "./PendingRequests.vue?vue&type=script&lang=js&"
export * from "./PendingRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports